import { BlobField } from "./BlobField";
import BN from "bn.js";
export class UintField extends BlobField {
    constructor(bytes, property) {
        super(bytes, property);
    }
    fromBuffer(buffer) {
        return new BN([...buffer]
            .reverse()
            .map((i) => `00${i.toString(16)}`.slice(-2))
            .join(""), 16);
    }
}
//# sourceMappingURL=UIntField.js.map